import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { TripAdvisorComponent } from './trip-advisor.component';

const MODULES = [
  CommonModule,
  MatIconModule,
  TranslateModule,
  LazyLoadImageModule
];

const COMPONENTS = [
  TripAdvisorComponent
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    TripAdvisorComponent
  ]
})
export class TripAdvisorModule { }
